// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1IrYKRb","container":"_2GCIzUy","close":"_1afbYq-"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Modal/Container.css
// module id = ./template/components/Modal/Container.css
// module chunks = client.sitechrome